//
// The options of a target column that is a list ("Auswahl").
//
// The list comes from the template's type note in BC and nowhere else; the
// converter never adds to it. A value counts as valid when it equals one of the
// labels, trimmed — that is how the conversion checks it
// (convertIssuesModule, case 'select'), so the editor offers exactly that.
//

import { selectLabels } from '@shared/valueMap'

export { selectLabels }

export type TTargetColumn = { column: string; field?: string; type?: string; format?: any }
export type TSelectOption = { value: string; label: string }

/** The out-table column a mapping row writes to, or null. */
export function targetColumn(data: any, target: string): TTargetColumn | null {
    const mapping: TTargetColumn[] = data?.outTable?.mapping ?? []
    return mapping.find((column) => column.column == target) ?? null
}

/**
 * What a picker for this column offers, or null when the column is no list.
 *
 * `current` is the value already stored. One that is not an option any more —
 * typed before there was a picker, or the template changed since — is kept and
 * marked, so opening the row does not quietly throw it away.
 */
export function selectPickerOptions(
    column: TTargetColumn | null,
    current: string | undefined,
    texts: { empty: string; notInList: string }
): TSelectOption[] | null {
    const labels = selectLabels(column)
    if (!labels) return null

    const options = labels.map((label) => ({ value: label, label: label || texts.empty }))
    const value = current ?? ''
    if (value !== '' && !labels.includes(value)) {
        options.push({ value, label: `${value} (${texts.notInList})` })
    }
    return options
}
